/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { IReservationPayload } from '../interfaces/field';
import { createPublicReservation } from '../services/reservation';
import { reservationsActions } from './definition';

function reservationIsLoading() {
    return {
        type: reservationsActions.RESERVATIONS_IS_LOADING,
    };
}

const reservationReset = () => {
    return {
        type: reservationsActions.RESERVATIONS_RESET,
    };
};

function reservationError(e: string) {
    return {
        type: reservationsActions.RESERVATIONS_ERROR,
        error: e,
        data: e,
    };
}

function reservationSet(reservations: any) {
    return {
        type: reservationsActions.RESERVATIONS,
        data: reservations,
    };
}

/**
 * Reducer to rest a reservations
 * @param values Data to reset reservations
 */
export const resetStateReservation = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(reservationReset());
    };
};

/**
 * Reducer to rest a reservations
 * @param values Data to reset reservations
 */
export const resetReservationReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(reservationReset());
    };
};

/**
 * Reducer to reset Reservations
 * @param values Values to reset reservations
 */
export const resetReservation = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(reservationReset());
    };
};

/**
 * Reducer  join reservation
 * @param values Data to create a join reservation
 */
export const createReservation = (values: IReservationPayload) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(reservationIsLoading());
            const reservation = await createPublicReservation(values);
            dispatch(reservationSet(reservation));
            // console.log({ reservation })
            /*if (reservation?.statusCode === 'RESERVATIONS_PLAYER_JOINED') {
                dispatch(reservationSet(reservation));
            }  else {
                dispatch(reservationError('No se pudo crear el partido'));
            }*/
        } catch (error: any) {
            console.log('error createReservation:', error);
            if (error.response && error.response.data) {
                if (error.response.data?.statusCode === 'PLAYER_ALREADY_IN_THIS_RESERVATIONS') {
                    dispatch(reservationError('Ya te uniste a este partido'));
                } else {
                    dispatch(reservationError('Error al crear reservación'));
                }

                return;
            } else {
                dispatch(reservationError('No se pudo crear la reservación'));
                return;
            }
        }
    };
};
